module.exports = __webpack_public_path__ + "static/drupal-c5a1543da8bf2a65ab4fcc1f9d681453.png";